import { createFileRoute } from '@tanstack/react-router'

import { validateListSearch } from '#/shared/lib/list-search'

import { OrganizationsPage } from '#/modules/organizations/organizations-page'

export const Route = createFileRoute('/_shell/organizations/')({
  component: OrganizationsPage,
  validateSearch: validateListSearch,
})
